module.exports = __webpack_public_path__ + "assets/5104f316eb9f636d110ddbf3d6c0c90d.mp3";